import IndustryLandingTemplate, { IndustryPageData } from '@/components/industry/IndustryLandingTemplate';

const homeServicesData: IndustryPageData = {
  slug: 'home-services',
  name: 'Home Services',
  heroHeadline: 'Build Trust for Your Home Service Business with Verified Reviews',
  heroSubheadline: 'Help your plumbing, electrical, cleaning, or repair business attract more customers with authentic Google reviews from satisfied homeowners.',
  painPoint: '96% of homeowners check reviews before hiring any home service professional',
  trustProblem: 'Letting strangers into your home requires trust. Without reviews, customers choose competitors.',
  challenges: [
    {
      title: 'Trust Barrier for Home Entry',
      description: 'Homeowners are cautious about who they let inside. Without verified reviews, they won\'t take the risk.',
    },
    {
      title: 'Service Area Visibility',
      description: 'When someone searches "plumber in Koramangala" or "electrician near me", you need to be visible.',
    },
    {
      title: 'Emergency Service Competition',
      description: 'For urgent repairs, customers pick the first highly-rated service provider they find.',
    },
    {
      title: 'Word-of-Mouth Dependency',
      description: 'Most home service businesses rely on referrals but miss out on the larger search-driven market.',
    },
  ],
  useCases: [
    {
      category: 'Plumbing Services',
      description: 'Reviews for pipe repairs, bathroom fitting, and water solutions.',
      keywords: ['plumber', 'pipe repair', 'bathroom fitting'],
    },
    {
      category: 'Electrical Work',
      description: 'Reviews for wiring, appliance repair, and electrical installations.',
      keywords: ['electrician', 'wiring work', 'appliance repair'],
    },
    {
      category: 'Cleaning & Pest Control',
      description: 'Reviews for deep cleaning, pest control, and sanitization.',
      keywords: ['home cleaning', 'pest control', 'deep cleaning'],
    },
  ],
  caseStudy: {
    businessType: 'Plumbing & Electrical Services',
    city: 'Bengaluru',
    challenges: [
      'Only 12 Google reviews despite 10+ years of service',
      'Not appearing in "emergency plumber" or area-specific searches',
      'Losing to aggregator platforms like Urban Company',
    ],
    solution: 'Implemented Review Plum with categories for Plumbing, Electrical, and Maintenance. Created WhatsApp-friendly review links for technicians to share after job completion.',
    results: [
      { metric: 'Google Reviews', value: '12 → 95' },
      { metric: 'Google Rating', value: '4.1 → 4.7' },
      { metric: 'Direct Inquiries', value: '+110%' },
      { metric: 'Repeat Customers', value: '+50%' },
    ],
  },
  sampleReviews: [
    {
      category: 'Plumbing Services',
      reviews: [
        {
          text: 'Called for an emergency pipe leak at 10 PM and they arrived within 30 minutes! The plumber was professional and fixed the issue quickly. Fair pricing with no hidden charges. Best plumbing service in Koramangala, Bengaluru. Saved in contacts for future needs.',
          keywords: ['plumber in Koramangala', 'emergency plumber', 'Bengaluru'],
        },
        {
          text: 'Hired them for complete bathroom renovation including new fittings and tiles. The work quality was excellent and they finished on time. The team was courteous and cleaned up after the work. Highly recommend for any plumbing work in South Bengaluru.',
          keywords: ['bathroom renovation', 'plumbing work', 'South Bengaluru'],
        },
      ],
    },
    {
      category: 'Electrical',
      reviews: [
        {
          text: 'Called for wiring work in my new flat and they did an excellent job! The electrician was experienced and used quality materials. Completed the entire 2BHK wiring in 3 days. Best electrician service in Whitefield, Bengaluru.',
          keywords: ['wiring work Whitefield', 'electrician Bengaluru', '2BHK wiring'],
        },
        {
          text: 'Had an electrical short circuit issue at midnight and they sent someone within an hour! Very professional service and fair pricing even for emergency calls. Highly recommend for any electrical work in East Bengaluru.',
          keywords: ['emergency electrician', 'electrical repair East Bengaluru', 'short circuit'],
        },
      ],
    },
    {
      category: 'Cleaning',
      reviews: [
        {
          text: 'Booked deep cleaning for my 3BHK before Diwali and the team did a fantastic job! They cleaned every corner including kitchen cabinets and bathroom tiles. The house looked brand new. Best deep cleaning service in Indiranagar.',
          keywords: ['deep cleaning Indiranagar', '3BHK cleaning', 'Diwali cleaning'],
        },
        {
          text: 'Regular monthly cleaning subscription has been a lifesaver! The staff is punctual and thorough. They bring their own equipment and eco-friendly cleaning products. Top home cleaning service in Bengaluru for busy professionals.',
          keywords: ['monthly cleaning', 'home cleaning Bengaluru', 'regular cleaning'],
        },
      ],
    },
  ],
  cityKeywords: [
    'plumber Mumbai',
    'electrician Delhi',
    'home service Bengaluru',
    'repair service Chennai',
    'cleaning service Pune',
    'pest control Hyderabad',
  ],
  nearMeKeywords: [
    'plumber near me',
    'electrician near me',
    'home repair nearby',
    'cleaning service close by',
    'pest control near me',
    'handyman nearby',
  ],
  ctaText: 'Get More Service Reviews',
};

export default function HomeServicesPage() {
  return <IndustryLandingTemplate data={homeServicesData} />;
}
